<template>
  <div
    class="column"
    style="
      padding: 0px;
      justify-content: center;
      display: flex;
      align-items: center;
    "
  >
    <div
      class="column has-text-left"
      style="display: flex; align-items: center; padding: 0"
    >
      <!-- <span class="heading">villa</span> -->
      <div
        @click.stop="onclickFindVilla"
        class="columns btn is-mobile"
        style="
          border: 1px solid #565656;
          height: 30px;
          width: 30px;
          margin: 5px;
        "
      >
        <div
          class="column"
          style="
            padding: 0;
            justify-content: center;
            align-items: center;
            display: flex;
          "
        >
          <img
            style="object-fit: contain; height: 20px"
            :src="require('@/assets/logo-villa-mobile.svg')"
            alt="The Villa Logo"
          />
        </div>
        <!-- <div class="column btn-label">หาคนขับ</div> -->
      </div>
    </div>
    <div
      class="column has-text-left"
      style="display: flex; align-items: center; padding: 0"
    >
      <!-- <span class="heading">lalamove</span> -->
      <div
        @click.stop="onClickFindLalamove"
        class="columns is-mobile btn"
        style="
          border: 1px solid #565656;
          height: 30px;
          width: 30px;
          margin: 5px;
        "
      >
        <div
          class="column"
          style="
            padding: 0;
            justify-content: center;
            align-items: center;
            display: flex;
          "
        >
          <img
            style="object-fit: contain; height: 20px"
            :src="require('@/assets/lalamove.png')"
            alt="The Villa Logo"
          />
        </div>
        <!-- <div class="column btn-label">หาคนขับ</div> -->
      </div>
      <!-- <b-button style="margin-right:5px;width:100%" class="is-small" type="is-warning">หาคนขับ</b-button> -->
    </div>
    <b-button
      @click.stop="onEditOrder"
      type="is-info"
      style="margin: 5px"
      class="is-small"
      outlined
      icon-right="pencil"
    />
  </div>
</template>

<script>
export default {
  props: ["order"],
  methods: {
    onClickFindLalamove(){
      this.$emit("onfindLalamove", this.order);
    },
    onclickFindVilla() {
      this.$emit("onfindVilla", this.order);
    },
    onEditOrder() {
      this.$emit("on-edit", this.order);
    },
  },
};
</script>

<style scoped>
.btn:hover {
  background-color: rgb(86, 86, 86);
  color: white;
}
.btn {
  color: rgb(86, 86, 86);
}
.btn-label {
  padding: 0;
  /* font-size: 10px; */
}
</style>